import * as React from "react";
import { RouteComponentProps } from "react-router";
import { observer } from "mobx-react";
import JobDescriptionRequestList from "./JobDescriptionRequestList";
import { JobDescriptionRequestPage } from "app/pages/JobDescriptionRequest/job-description-request.page";

type Props = RouteComponentProps<{ entityId?: string }>;

@observer
export class JobDescriptionRequestManagement extends React.Component<Props> {
  static PATH = "/jobDescriptionRequest";
  static NEW_SUBPATH = "new";

  render() {
    const { entityId } = this.props.match.params;
    return (
      <>
        {entityId ? (
          <JobDescriptionRequestPage />
          // <JobDescriptionRequestEdit entityId={entityId} />
        ) : (
          <JobDescriptionRequestList />
        )}
      </>
    );
  }
}
